/**
 * Tree-shakable ECharts surface — register only the components swimset uses.
 *
 * Importing `echarts` whole pulls every chart type + every renderer (~1MB
 * minified before gzip). swimset uses line, pie, custom; canvas renderer;
 * tooltip, grid, markArea components. Cuts bundle weight to roughly a third —
 * meaningful on WKWebView cold start.
 *
 * Use: `import echarts from "$lib/echarts"; echarts.init(el); echarts.graphic.LinearGradient(...)`.
 */
import * as echarts from "echarts/core";
import { LineChart, PieChart, CustomChart } from "echarts/charts";
import { TooltipComponent, GridComponent, MarkAreaComponent, LegendComponent, MarkLineComponent, MarkPointComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  LineChart,
  PieChart,
  CustomChart,
  TooltipComponent,
  GridComponent,
  MarkAreaComponent,
  LegendComponent,
  MarkLineComponent,
  MarkPointComponent,
  CanvasRenderer,
]);

export default echarts;
export { echarts };
